import { BrandLockup } from '@/components/brand/BrandMark';
import { NotificationCenter } from '@/components/notifications/NotificationCenter';
import { ThemeToggle } from '@/components/ThemeToggle';
import { Button } from '@/components/ui/button';
import { useCompany } from '@/hooks/use-company';
import { getPublicCompanyUrl } from '@/lib/public-company';
import { ExternalLink } from 'lucide-react';
import { MobileNav } from './MobileNav';
import { UserMenu } from './UserMenu';

export function AppTopbar() {
  const { activeCompany } = useCompany();
  const publicCompanyUrl =
    activeCompany?.publicPageEnabled && activeCompany.slug ? getPublicCompanyUrl(activeCompany.slug) : null;

  return (
    <header className="bg-background/95 supports-[backdrop-filter]:bg-background/80 border-border sticky top-0 z-30 flex h-16 items-center border-b px-4 backdrop-blur sm:px-6 lg:h-20 lg:px-8">
      <div className="flex min-w-0 flex-1 items-center gap-3 lg:hidden">
        <MobileNav />
        <BrandLockup className="min-w-0 gap-2" textClassName="truncate text-xl" />
      </div>

      <div className="ml-auto flex shrink-0 items-center gap-1 sm:gap-2">
        {publicCompanyUrl && (
          <Button asChild variant="outline" size="sm" className="gap-2 px-2 sm:px-3">
            <a href={publicCompanyUrl} target="_blank" rel="noreferrer" aria-label="Ver página pública da empresa">
              <ExternalLink className="h-4 w-4" />
              <span className="hidden sm:inline">Ver página pública</span>
            </a>
          </Button>
        )}
        <ThemeToggle />
        <NotificationCenter />
        <div className="bg-border mx-1 hidden h-8 w-px sm:block" />
        <UserMenu />
      </div>
    </header>
  );
}
